/* trekvoss Dachlast-Check v3 — Design 3a Akkordeon: Marke > Modell > Baujahr, Chip, Schritt-Hinweis, Lastbalken */
(function () {
  'use strict';

  if (customElements.get('trekvoss-dachlast-check')) return;

  var dbCache = null;

  var ICONS = {
    fit: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg>',
    no:  '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>'
  };

  function kg(n) {
    return String(Math.round(n * 10) / 10).replace('.', ',') + ' kg';
  }

  class TrekvossDachlastCheck extends HTMLElement {
    connectedCallback() {
      this.zelt = parseFloat(this.dataset.zeltGewicht);
      this.traeger = parseFloat(this.dataset.traegerGewicht || '4');
      this.reserveWarn = parseFloat(this.dataset.reserveWarn || '15');
      this.entries = [];

      var acc = this.querySelector('details.tvdc-acc');
      if (acc && window.matchMedia('(min-width: 700px)').matches) acc.open = true;

      this.elBrand = this.querySelector('[data-dc-marke]');
      this.elModel = this.querySelector('[data-dc-modell]');
      this.elYear = this.querySelector('[data-dc-baujahr]');
      this.elResult = this.querySelector('[data-dc-result]');
      this.elHint = this.querySelector('[data-dc-hint]');
      this.elChip = this.querySelector('[data-dc-chip]');

      var self = this;
      if (!dbCache) {
        dbCache = fetch(this.dataset.dbUrl).then(function (r) {
          if (!r.ok) throw new Error('DB HTTP ' + r.status);
          return r.json();
        });
      }
      dbCache.then(function (db) {
        self.entries = db.fahrzeuge || [];
        self.fillBrands();
      }).catch(function (err) {
        self.showError();
        if (window.console) console.warn('Dachlast-Check: DB nicht ladbar', err);
      });

      this.elBrand.addEventListener('change', function () { self.onBrand(); });
      this.elModel.addEventListener('change', function () { self.onModel(); });
      this.elYear.addEventListener('change', function () { self.render(); });

      var cta = this.querySelector('[data-dc-cart]');
      if (cta) cta.addEventListener('click', function () { self.addToCart(); });

      var book = this.querySelector('[data-dc-book]');
      if (book) book.addEventListener('click', function () { self.scrollToBooking(); });
    }

    scrollToBooking() {
      var candidates = document.querySelectorAll('[id*="izyrent" i], [class*="izyrent" i]');
      var target = null;
      for (var i = 0; i < candidates.length; i++) {
        if (candidates[i].offsetHeight > 20) { target = candidates[i]; break; }
      }
      if (!target) target = document.querySelector('form[action*="/cart/add"]');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var input = target.querySelector('input, button, select');
        if (input && typeof input.focus === 'function') {
          setTimeout(function () { input.focus({ preventScroll: true }); }, 450);
        }
      }
    }

    reset(sel) {
      sel.innerHTML = '<option value="">Wählen …</option>';
      sel.disabled = true;
    }

    fill(sel, items, getValue, getLabel) {
      this.reset(sel);
      items.forEach(function (it, i) {
        var o = document.createElement('option');
        o.value = String(getValue(it, i));
        o.textContent = getLabel(it);
        sel.appendChild(o);
      });
      sel.disabled = false;
    }

    fillBrands() {
      var brands = [];
      this.entries.forEach(function (e) { if (brands.indexOf(e.marke) === -1) brands.push(e.marke); });
      brands.sort(function (a, b) { return a.localeCompare(b, 'de'); });
      this.fill(this.elBrand, brands, function (b) { return b; }, function (b) { return b; });
    }

    onBrand() {
      var brand = this.elBrand.value;
      var models = [];
      this.entries.forEach(function (e) {
        if (e.marke === brand && models.indexOf(e.modell) === -1) models.push(e.modell);
      });
      models.sort(function (a, b) { return a.localeCompare(b, 'de'); });
      if (brand) { this.fill(this.elModel, models, function (m) { return m; }, function (m) { return m; }); }
      else { this.reset(this.elModel); }
      this.reset(this.elYear);
      this.hideResult();
    }

    onModel() {
      var brand = this.elBrand.value, model = this.elModel.value;
      var gens = [];
      this.entries.forEach(function (e, i) {
        if (e.marke === brand && e.modell === model) gens.push({ e: e, i: i });
      });
      if (model) { this.fill(this.elYear, gens, function (g) { return g.i; }, function (g) { return g.e.baujahr || 'alle Baujahre'; }); }
      else { this.reset(this.elYear); }
      this.hideResult();
    }

    hideResult() {
      this.elResult.classList.remove('visible');
      if (this.elChip) { this.elChip.className = 'tvdc-chip'; this.elChip.textContent = ''; }
      if (this.elHint) {
        this.elHint.hidden = false;
        this.elHint.textContent = !this.elBrand.value ? 'Schritt 1 von 3 — wähle zuerst deine Marke.'
          : !this.elModel.value ? 'Schritt 2 von 3 — wähle dein Modell.'
          : 'Schritt 3 von 3 — wähle das Baujahr.';
      }
    }

    render() {
      var idx = this.elYear.value;
      if (idx === '') { this.hideResult(); return; }
      var v = this.entries[parseInt(idx, 10)];
      if (!v) { this.hideResult(); return; }

      var need = this.zelt + this.traeger;
      var load = v.dachlast_dyn_kg;
      var reserve = load - need;
      var status = reserve >= 0 ? 'fit' : 'no';
      var knapp = status === 'fit' && reserve < this.reserveWarn;

      if (this.elHint) this.elHint.hidden = true;

      if (this.elChip) {
        this.elChip.className = 'tvdc-chip ' + status;
        this.elChip.textContent = status === 'fit' ? 'Passt' : 'Passt nicht';
      }

      var card = this.querySelector('[data-dc-resultcard]');
      card.className = 'tvdc-resultcard ' + status;

      var statusEl = this.querySelector('[data-dc-status]');
      statusEl.innerHTML = ICONS[status] + '<span>' + (
        status === 'fit' ? 'Passt — ' + kg(reserve) + ' Reserve' : 'Passt leider nicht'
      ) + '</span>';

      var fill = this.querySelector('[data-dc-fill]');
      fill.style.width = Math.min(100, (need / load) * 100) + '%';
      fill.classList.toggle('is-fit', status === 'fit');

      this.querySelector('[data-dc-need]').textContent = kg(need);
      this.querySelector('[data-dc-load]').textContent = kg(load);

      var tentName = this.dataset.productTitle || 'Dieses Zelt';
      this.querySelector('[data-dc-detail]').textContent =
        status === 'no'
          ? 'Zelt + Träger wiegen ' + kg(need) + ' — die zulässige Dachlast von ' + v.marke + ' ' + v.modell + ' liegt bei ' + kg(load) + '. ' + tentName + ' ist während der Fahrt ' + kg(-reserve) + ' zu schwer.'
          : 'Dachlast ' + kg(load) + ' (' + v.marke + ' ' + v.modell + ') − Zelt ' + kg(this.zelt) + ' − Träger ca. ' + kg(this.traeger) + ' = ' + kg(reserve) + ' Reserve während der Fahrt.' +
            (knapp ? ' Tipp: Mit einem leichten Träger und ohne weiteres Dachgepäck bist du auf der sicheren Seite.' : '');

      var hintEl = this.querySelector('[data-dc-hinweis]');
      hintEl.textContent = v.hinweis || '';
      hintEl.hidden = !v.hinweis;

      this.querySelector('[data-dc-act-buy]').hidden = status === 'no';
      this.querySelector('[data-dc-act-alt]').hidden = status !== 'no';

      this.elResult.classList.add('visible');
    }

    addToCart() {
      var form = document.querySelector('form[action*="/cart/add"]');
      if (form && typeof form.requestSubmit === 'function') { form.requestSubmit(); return; }
      var id = this.dataset.variantId;
      if (!id) return;
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
      }).then(function () { window.location.href = '/cart'; });
    }

    showError() {
      this.elBrand.disabled = true;
      this.elModel.disabled = true;
      this.elYear.disabled = true;
      if (this.elHint) this.elHint.hidden = true;
      var err = this.querySelector('[data-dc-error]');
      if (err) err.hidden = false;
    }
  }

  customElements.define('trekvoss-dachlast-check', TrekvossDachlastCheck);
})();
